export const SET_CONVERSATION_ID = 'SET_CONVERSATION_ID';
export const CLEAR_CONVERSATION_ID = 'CLEAR_CONVERSATION_ID';
export const SET_USER='SET_USER'
export const SET_CONVERSATIONS = 'SET_CONVERSATIONS';
export const CLEAR_CONVERSATIONS = 'CLEAR_CONVERSATIONS';